import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const BookingChart = ({ data }) => {
  const { t } = useTranslation();
  
  const chartData = data.map(month => ({
    month: month.monthName,
    [t('admin.reports.charts.total_bookings')]: month.totalBookings || 0,
    [t('admin.reports.charts.completed')]: month.totalCompleted || 0,
    [t('admin.reports.charts.pending')]: month.totalPending || 0,
    [t('admin.reports.charts.cancelled')]: month.totalCancelled || 0
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="chart-tooltip">
          <p className="tooltip-label">{`${label}`}</p>
          {payload.map((entry, index) => (
            <p key={index} className="tooltip-item" style={{ color: entry.color }}>
              {`${entry.dataKey}: ${entry.value}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="booking-chart-container">
      <div className="chart-header">
        <h2 className="chart-title">{t('admin.reports.charts.monthly_stats_title')}</h2>
        <p className="chart-subtitle">{t('admin.reports.charts.monthly_stats_subtitle')}</p>
      </div>
      
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={chartData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e7ff" />
            <XAxis 
              dataKey="month" 
              tick={{ fontSize: 12, fill: '#64748b' }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis tick={{ fontSize: 12, fill: '#64748b' }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar 
              dataKey={t('admin.reports.charts.total_bookings')}
              fill="#3b82f6" 
              name={t('admin.reports.charts.total_bookings')}
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey={t('admin.reports.charts.completed')}
              fill="#10b981" 
              name={t('admin.reports.charts.completed')}
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey={t('admin.reports.charts.pending')}
              fill="#f59e0b" 
              name={t('admin.reports.charts.pending')}
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey={t('admin.reports.charts.cancelled')}
              fill="#ef4444" 
              name={t('admin.reports.charts.cancelled')}
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BookingChart;